export const acceptMusicFileExt = ".mp3, .mp4, .wav, .aiff, .aac, .ogg, .wma, .flac, .alac"
export const acceptDocFileExt = "image/*, .docx, .doc, .pdf, .txt, text/*"